import { render, staticRenderFns } from "./card-info-pop.vue?vue&type=template&id=563f5854&scoped=true&"
import script from "./card-info-pop.vue?vue&type=script&lang=js&"
export * from "./card-info-pop.vue?vue&type=script&lang=js&"
import style0 from "./card-info-pop.vue?vue&type=style&index=0&id=563f5854&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f5854",
  null
  
)

export default component.exports